import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            精选推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            深度内容阅读
          </h2>
          <p className="mt-2 text-sm text-foreground-600">编辑精选的影视深度好文</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item) => (
            <div key={item.id} className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden">
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          {cardItems.slice(3, 5).map((item) => (
            <div key={item.id} className="group cursor-pointer bg-background-50 rounded-xl p-5 flex gap-4 items-start">
              <div className="w-24 h-24 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}